import { useMutation } from "@tanstack/react-query";
import { recoveryPassword } from "../../../api/requests/recoveryPassword";
import { useNotificationStore } from "@src/shared/components/Notification";
import { AxiosError } from "axios";

export const useRecoveryPassword = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: recoveryPassword,
    onError: (error: AxiosError) => {
      const response = error?.response?.data as { detail: string };
      const detail = response?.detail || "";

      if (detail.includes("Invalid code")) {
        showAlert(
          "Введенный код не соответствует отправленному. Введите правильный код подтверждения",
          "error"
        );
        return;
      }
      showAlert(error.message, "error");
    },
  });
  return query;
};
